import SportHistory from './SportHistory';

export default SportHistory;
